'use client';
import React from 'react';
import { usePathname } from 'next/navigation';
import { StandardHero } from './StandardHero';
import { getActiveGovTradesTab } from './getActiveGovTradesTab';

export const GovTradesNotFoundHero = ({ search }: { search: React.ReactNode }) => {
  const pathname = usePathname() ?? '';
  if (getActiveGovTradesTab(pathname)) return null;
  return <StandardHero activeTab={null} search={search} url="https://www.benzinga.com/government-trades" showShare={false} />;
};
